import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Maintenance } from '@features/maintenance/maintenance';

export const MaintenanceActions = createActionGroup({
  source: 'Maintenance Component',
  events: {
    loadMaintenance: emptyProps(),
    loadMaintenanceSuccess: props<{ maintenance: Maintenance }>(),
    loadMaintenanceFailure: props<{ error: string }>(),
  },
});
